<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" dense>
        <template v-slot:top>
          <v-toolbar flat>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('setting-hpp.update')"
                  color="success"
                  v-on="on"
                  dark
                  rounded
                  @click="openUpdateSetting"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Update Setting</span>
            </v-tooltip>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }">
          {{ items.map(x => x).indexOf(item) + 1 }}
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <DialogUpdateSetting :dialog="dialog" :item="item" @close="close" @save="updateSetting" />
  </v-row>
</template>

<script>
import DialogUpdateSetting from "./DialogUpdateSetting.vue";
export default {
  components: {
    DialogUpdateSetting,
  },
  data: () => ({
    items: [],
    item: {},
    dialog: false,
    headers: [
      {
        id: 1,
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Created At",
        value: "createdAt",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 4,
        text: "Percentage",
        value: "percentage",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Used",
        value: "used",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Created By",
        value: "createdBy",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("settingHpp/getAll")
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    openUpdateSetting() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("settingHpp/getSetting")
        .then(response => {
          this.item = response.data;
          this.dialog = true;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    close() {
      this.dialog = false;
    },
    updateSetting(item) {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("settingHpp/updateSetting", item)
        .then(() => {
          this.initialize();
          this.close();
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
};
</script>

<style></style>
